module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productlist custom-full-border",
    class: [_vm.callerComp === 'Similar Products' ? 'similiarProdMobile' : '', _vm.product && _vm.product.tiptiles ? 'h-full' : 'productCard'],
    attrs: {
      "id": _vm.product ? _vm.product.tiptiles ? 'productlist-' + 'tiptile-' + _vm.product.tiptiles.id : 'productlist-' + _vm.product.id : null
    }
  }, [(!(_vm.product && _vm.product.tiptiles)) ? _c('router-link', {
    attrs: {
      "to": _vm.navigateToProd()
    }
  }, [_c('div', {
    directives: [{
      name: "lazyloadImage",
      rawName: "v-lazyloadImage",
      value: (Object.assign({}, _vm.getTatvicprImpression,
        {isSelectedCountryIndia: _vm.isSelectedCountryIndia,
        enableVisenzeSearch: _vm.enableVincenzeSearch && _vm.enableVincenzeSearch.status,
        widget_current_route: _vm.currentRouteMoengage})),
      expression: "{...getTatvicprImpression, isSelectedCountryIndia, enableVisenzeSearch : enableVincenzeSearch && enableVincenzeSearch.status, widget_current_route : currentRouteMoengage}"
    }],
    staticClass: "imgBlock custom-border",
    class: 'listhover ' + _vm.pclass,
    on: {
      "click": function($event) {
        _vm.trigerEvent(_vm.position)
      }
    }
  }, [_c('div', {
    staticClass: "listhoverimg",
    attrs: {
      "data-url": _vm.baseImgPath + _vm.path + (_vm.parry && _vm.parry[1])
    }
  }), _vm._v(" "), (_vm.showCarouselImages) ? _c('carousel', {
    ref: "myCarousel",
    attrs: {
      "perPage": 1,
      "navigationEnabled": false,
      "paginationEnabled": false,
      "navigationNextLabel": "",
      "paginationPadding": 2,
      "paginationSize": 7,
      "paginationPosition": "bottom",
      "navigationPrevLabel": "",
      "easing": 'linear',
      "speed": 2000
    }
  }, _vm._l((_vm.product.images), function(pr, index) {
    return _c('slide', {
      key: index
    }, [_c('img', {
      directives: [{
        name: "imageBackground",
        rawName: "v-imageBackground",
        value: (_vm.isPrImgMounted ? '1080:1440' : ''),
        expression: "isPrImgMounted ? '1080:1440' : ''"
      }],
      staticClass: "img-auto",
      attrs: {
        "src": _vm.baseImgPath + _vm.path + (pr) && _vm.baseImgPath + _vm.path + (_vm.parry && _vm.parry[index]),
        "fallback": "https://tss-static-images.gumlet.io/blankimg.jpg",
        "placeholder": 'https://tss-static-images.gumlet.io/blankimg.jpg',
        "blur": 20,
        "alt": (_vm.productTitle + " " + _vm.listCat + " Online"),
        "title": (_vm.productTitle + " " + _vm.listCat + " at The Souled Store"),
        "width": "280",
        "height": "370"
      },
      on: {
        "load": function($event) {
          _vm.loadimage(index, _vm.product.images.length)
        }
      }
    })])
  })) : _c('img', {
    directives: [{
      name: "imageBackground",
      rawName: "v-imageBackground",
      value: (_vm.isPrImgMounted ? '1080:1440' : ''),
      expression: "isPrImgMounted ? '1080:1440' : ''"
    }],
    staticClass: "customFade custom-border img-auto",
    class: (_vm.timerData && _vm.timerData.showBlur) || (_vm.product && _vm.product.isBlurOnPlp) ? 'img-blur' : '',
    attrs: {
      "fallback": "https://tss-static-images.gumlet.io/blankimg.jpg",
      "placeholder": 'https://tss-static-images.gumlet.io/blankimg.jpg',
      "blur": 20,
      "data-url": _vm.baseImgPath + _vm.path + (_vm.parry && _vm.parry[0]),
      "alt": (_vm.productTitle + " " + _vm.listCat + " Online"),
      "title": (_vm.productTitle + " " + _vm.listCat + " at The Souled Store"),
      "width": "280",
      "height": "370"
    },
    on: {
      "load": _vm.loadimage
    }
  }), _vm._v(" "), (_vm.avgRating >= 1 && _vm.bannerplprating) ? _c('div', {
    staticClass: "ratingPLP"
  }, [_c('span', [_vm._v(_vm._s(_vm.avgRating))]), _vm._v(" "), _c('img', {
    staticClass: "starRating",
    attrs: {
      "src": "https://w7.pngwing.com/pngs/566/674/png-transparent-green-star-blue-angle-leaf-thumbnail.png"
    }
  }), _vm._v(" "), _c('div', [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getDataValue(_vm.ratingCount)))])]) : _vm._e(), _vm._v(" "), ((_vm.prodType === 1 || _vm.prodType === 6) && _vm.pstock <= 0) ? _c('div', {
    class: _vm.showImageBlurSoldOutDesign ? 'souled-out-image-blur' : 'souledout'
  }, [_vm._v(_vm._s(_vm.showImageBlurSoldOutDesign ? 'Souled Out' : ''))]) : (_vm.prodType === 3 && _vm.isStockConfig <= 0) ? _c('div', {
    class: _vm.showImageBlurSoldOutDesign ? 'souled-out-image-blur' : 'souledout'
  }, [_vm._v(_vm._s(_vm.showImageBlurSoldOutDesign ? 'Souled Out' : ''))]) : _vm._e(), _vm._v(" "), (_vm.souledout) ? _c('div', {
    class: _vm.showImageBlurSoldOutDesign ? 'souled-out-image-blur' : 'souledout'
  }, [_vm._v(_vm._s(_vm.showImageBlurSoldOutDesign ? 'Souled Out' : ''))]) : (_vm.prodType === 1 && _vm.pstock <= 0 && _vm.urlKey === 'harry-potter-hufflepuff-sigil-scarf') ? _c('div', {
    staticClass: "coming-soon"
  }, [_vm._v("coming soon")]) : _vm._e(), _vm._v(" "), (_vm.mockUpTag && Object.keys(_vm.mockUpTag).length) ? _c('div', {
    staticClass: "mockup-tag",
    class: _vm.getMockUpTagPositionClass(_vm.mockUpTag.tag_position)
  }, [_c('span', {
    style: ({
      backgroundColor: _vm.mockUpTag.background_color,
      color: _vm.mockUpTag.text_color
    })
  }, [_vm._v("\n          " + _vm._s(_vm.mockUpTag.tag_name) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.timerData && Object.keys(_vm.timerData).length) ? _c('div', {
    staticClass: "pabsolute timer-container w-full d-flex flex-column justify-content-center align-items-center"
  }, [(_vm.timerData.showCountDown) ? _c('CountdownPLP', {
    attrs: {
      "starttime": _vm.timerData.startDate,
      "endtime": _vm.timerData.endDate,
      "color": _vm.timerData.timerColor,
      "showTimer": _vm.timerData.showTimer,
      "pretext": _vm.timerData.liveSaleText,
      "showEarlyText": _vm.timerData.showEarlyText,
      "days": _vm.timerData.days,
      "minutes": _vm.timerData.minutes,
      "hours": _vm.timerData.hours,
      "seconds": _vm.timerData.seconds,
      "now": _vm.timerData.now,
      "callerComp": "imgBlock"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.product && (!_vm.product.isProductLocked || !_vm.product.targetDate)) ? _c('div', {
    staticStyle: {
      "padding": "0px 5px 0px 10px"
    }
  }, [_c('div', {
    style: (_vm.isDesktop ? 'display: grid;' : 'display:flex;')
  }, [_c('h5', {
    staticClass: "text-left",
    staticStyle: {
      "color": "#585C70"
    }
  }, [_vm._v(_vm._s(_vm.productTitle))]), _vm._v(" "), (_vm.isWishlist(_vm.prm) && _vm.isBlurProductClickablePdp) ? _c('div', {
    staticClass: "wishlistIcon pl-1 pb-2 pr-1",
    class: _vm.prm.id && _vm.wishlistItemsIDs && _vm.wishlistItemsIDs[_vm.prm.id] ? 'wishlistActive' : 'wishlist',
    style: (_vm.callerComp !== 'Search Page' && _vm.callerComp !== 'PLP Page' ? 'right: 35px !important;' : ''),
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateWishlist(_vm.prm, $event, _vm.position)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 d-flex justify-content-between",
    attrs: {
      "title": _vm.productCat
    }
  }, [_c('div', {
    staticClass: "listprice ecltext",
    class: _vm.mockUpLabel && Object.keys(_vm.mockUpLabel).length && _vm.isLabelLieInTime ? 'category-txt' : ''
  }, [(_vm.listCat) ? _c('span', {
    style: ({
      fontSize: !this.isDesktop ? '11px' : ''
    })
  }, [_vm._v(_vm._s(_vm.listCat))]) : _c('span', {
    style: ({
      fontSize: !this.isDesktop ? '11px' : ''
    })
  }, [_vm._v(_vm._s(_vm.productCat))])]), _vm._v(" "), (_vm.mockUpLabel && Object.keys(_vm.mockUpLabel).length && _vm.isLabelLieInTime) ? _c('div', {
    staticClass: "d-flex align-items-center label-container prelative"
  }, [_c('i', {
    staticClass: "fa fa-bolt pabsolute",
    style: ({
      borderColor: _vm.mockUpLabel.label.label_background_color
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "fbold ecltext",
    style: ({
      backgroundColor: _vm.mockUpLabel.label.label_background_color,
      color: _vm.mockUpLabel.label.label_text_color
    })
  }, [_vm._v(_vm._s(_vm.mockUpLabel.label.label_name))])]) : _vm._e()]), _vm._v(" "), (_vm.productPrice) ? _c('div', {
    staticClass: "col-12",
    staticStyle: {
      "padding-right": "0px"
    }
  }, [(_vm.getround(_vm.spprice) || (_vm.isExclusive && _vm.getround(_vm.exclusivePrice))) ? _c('span', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 special-products_pricing"
  }, [(_vm.isExclusive && _vm.showMemberExclusivePrice && _vm.getround(_vm.exclusivePrice)) ? _c('span', {
    staticClass: "membership-product-price"
  }, [_c('span', {
    staticStyle: {
      "color": "#121212"
    }
  }, [_vm._v("Membership Price")]), _vm._v(" "), _c('span', {
    staticClass: "fsemibold",
    staticStyle: {
      "color": "#121212"
    }
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s((_vm.exclusivePrice && _vm.getround(_vm.exclusivePrice) || 0)))])]) : _c('span', {
    staticClass: "offer fsemibold"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.isExclusive ? (_vm.exclusivePrice && _vm.getround(_vm.exclusivePrice) || 0) : _vm.spprice && _vm.getround(_vm.spprice)))]), _vm._v(" "), _c('span', {
    staticClass: "product-price",
    staticStyle: {
      "text-decoration": "line-through",
      "color": "#ccc"
    }
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.getround(_vm.productPrice)))]), _vm._v(" "), (!_vm.isExclusive && _vm.spprice > 0) ? _c('span', {
    staticClass: "percentage-off"
  }, [(_vm.isNonExclusiveSavingsInPercent) ? _c('span', [_vm._v("\n                    " + _vm._s(((_vm.getround((_vm.productPrice - (_vm.isExclusive ? _vm.exclusivePrice : _vm.spprice)) / _vm.productPrice * 100)) + "%")) + " " + _vm._s((_vm.nonMemberSavingsTxt && _vm.nonMemberSavingsTxt.tag_text) || 'OFF') + "\n                  ")]) : _c('span', [_vm._v(_vm._s(_vm.currencySymbol) + "\n                    " + _vm._s(("" + (_vm.getround(_vm.productPrice) - _vm.getround((_vm.isExclusive ? _vm.exclusivePrice : _vm.spprice))))) + " " + _vm._s((_vm.nonMemberSavingsTxt && _vm.nonMemberSavingsTxt.tag_text) || 'OFF') + "\n                  ")])]) : _vm._e()])])]) : (['50000-points-offer', '25000-points-offer', '12000-points-offer'].includes(_vm.urlKey)) ? _c('span', [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.$parent.$parent.currencyFormate(_vm.getround(_vm.productPrice))))]) : _c('span', {
    staticClass: "offer fsemibold"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.productPrice && _vm.getround(_vm.productPrice)))]), _vm._v(" "), (_vm.showPriceInclusiveOnPlp && _vm.isSelectedCountryIndia) ? _c('span', {
    staticClass: "mrp-text",
    style: ({
      fontSize: !_vm.isDesktop ? '13px' : ''
    })
  }, [_vm._v(_vm._s(_vm.showPriceInclusiveOnPlp.tag_text))]) : _vm._e(), _vm._v(" "), (_vm.showMrpOnPlpGlobal && !_vm.isSelectedCountryIndia) ? _c('span', {
    staticClass: "mrp-text",
    style: ({
      fontSize: !_vm.isDesktop ? '13px' : ''
    })
  }, [_vm._v(_vm._s(_vm.showMrpOnPlpGlobal.tag_text))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.gstInClusiveLabel && Object.keys(_vm.gstInClusiveLabel).length) ? _c('div', {
    staticClass: "gstInclusiveLabel"
  }, [_c('span', {
    style: (("color: " + (_vm.gstInClusiveLabel.banner_text_color) + "; background: " + (_vm.gstInClusiveLabel.banner_color) + ";"))
  }, [_vm._v(_vm._s(_vm.gstInClusiveLabel.tag_text))])]) : _vm._e(), _vm._v(" "), (_vm.getround(_vm.exclusivePrice) && _vm.getround(_vm.productPrice) && _vm.isExclusive && !_vm.showMemberExclusivePrice) ? _c('div', {
    staticClass: "col-12 percentage-off member-savings pb-1"
  }, [(_vm.isExclusiveSavingsInPercent) ? _c('span', [_vm._v(_vm._s(_vm.getround(((_vm.productPrice - _vm.exclusivePrice) / _vm.productPrice) * 100)) + "% " + _vm._s((_vm.memberSavingsTxt && _vm.memberSavingsTxt.tag_text) || 'Member Savings'))]) : _c('span', [_vm._v(_vm._s((_vm.memberSavingsTxt && _vm.memberSavingsTxt.tag_text) || 'Member Savings') + " " + _vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.getround(_vm.productPrice) - _vm.getround(_vm.exclusivePrice)))])]) : _vm._e()]), _vm._v(" "), (this.$route.path === '/artists/exclusive-deals' && !_vm.isExclusive) ? _c('div', {
    staticClass: "ex-price",
    on: {
      "click": function($event) {
        _vm.togglePopup(_vm.EXCLUSIVE_PRODUCT)
      }
    }
  }, [_vm._v("For Excl. Member "), _c('i', {
    staticClass: "fa fa-info-circle pointer"
  }), _c('span', {
    staticClass: "fbold",
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.exclusivePrice))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.product && _vm.product.isProductLocked) ? _c('div', {
    staticClass: "notify-me-btn"
  }, [_c('notifyMe', {
    attrs: {
      "parentid": _vm.product.id,
      "proType": _vm.product.isProductLocked && _vm.isTargetDateInFuture ? 'TIMER' : _vm.product.isProductLocked ? 'LOCK' : '',
      "isOptions": true,
      "product": _vm.product
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.product && _vm.product.isProductLocked && _vm.isTargetDateInFuture) ? _c('div', {
    staticClass: "countdown-timer"
  }, [_c('CountdownTimer', {
    attrs: {
      "targetDate": _vm.product.targetDate
    }
  })], 1) : _vm._e()]) : _c('div', {
    staticClass: "imgBlock h-full"
  }, [(_vm.product.tiptiles.isClickable && _vm.product.tiptiles.navLink && _vm.isExternalLink(_vm.product.tiptiles.navLink)) ? _c('a', {
    directives: [{
      name: "bannerImageLoad",
      rawName: "v-bannerImageLoad",
      value: (_vm.getBannerImpressionData),
      expression: "getBannerImpressionData"
    }],
    staticClass: "h-full",
    attrs: {
      "href": _vm.product.tiptiles.navLink,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    staticClass: "h-full w-full fit-cover customFade",
    attrs: {
      "data-url": _vm.parry[0],
      "alt": _vm.productTitle
    },
    on: {
      "load": _vm.loadimage,
      "click": _vm.tiptileClick
    }
  })]) : (_vm.product.tiptiles.isClickable && _vm.product.tiptiles.navLink) ? _c('router-link', {
    directives: [{
      name: "bannerImageLoad",
      rawName: "v-bannerImageLoad",
      value: (_vm.getBannerImpressionData),
      expression: "getBannerImpressionData"
    }],
    staticClass: "h-full",
    class: 'listhover ' + _vm.pclass,
    attrs: {
      "to": _vm.product.tiptiles.navLink
    }
  }, [_c('img', {
    staticClass: "h-full w-full fit-cover customFade",
    attrs: {
      "data-url": _vm.parry[0],
      "alt": _vm.productTitle
    },
    on: {
      "load": _vm.loadimage,
      "click": _vm.tiptileClick
    }
  })]) : _c('div', {
    directives: [{
      name: "bannerImageLoad",
      rawName: "v-bannerImageLoad",
      value: (_vm.getBannerImpressionData),
      expression: "getBannerImpressionData"
    }],
    staticClass: "pointer-none h-full"
  }, [_c('img', {
    staticClass: "h-full w-full fit-cover customFade",
    attrs: {
      "data-url": _vm.parry[0],
      "alt": _vm.productTitle
    },
    on: {
      "load": _vm.loadimage,
      "click": _vm.tiptileClick
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d5b3c05"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/imgBlock.vue
// module id = 890
// module chunks = 113